import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GridPlugin } from '@df/catalog-ui/listing/plugin/grid/grid-plugin';
import { ProductListingComponentDef } from '@df/catalog-ui/product/listing/product-listing.component.def';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { IProductDataV2 } from '@df/catalog/product/product';
import { InfiniteScrollModule } from '@df/module-infinite-scroll/infinite-scroll.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Category } from '../../catalog/category/category.decorator';
import { Product } from '../../catalog/product/product.decorator';
import { ProductComponent } from '../../catalog/product/product/product.component';
import { ProductListingToolsComponent } from './product-listing-tools.component';
import { ProductListing } from './product-listing.decorator';
import { AfterContentInitDirective } from '@df/ui/common/after-content-init.directive';

declare module '@df/search/search.interfaces' {
    namespace Search {
        interface IResult {
            term?: string;
        }
    }
}
@Component({
    selector: 'product-listing',
    templateUrl: 'product-listing.html',
    styleUrls: ['./product-listing.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, ProductComponent, GridModule, InfiniteScrollModule, ProductListingToolsComponent, AfterContentInitDirective]
})
export class ProductListingComponent extends ProductListingComponentDef {
    override _listing?: ProductListing;
    /**
     * Install GridPlugin when listing is set
     */

    /**
     * Listing setter
     */
    @Input()
    override set listing(listing: ProductListing) {
        super.listing = listing;
    }

    @Input()
    override category?: Category<ICategoryDataV3>;

    /**
     * Listing getter
     */
    override get listing(): ProductListing | undefined {
        return this._listing;
    }

    protected override onListingChange() {
        if (this.listing) {
            new GridPlugin(this.listing, {
                layouts: {
                    '1x1': ['S', 'M', 'L', 'X'],
                    '2x1': ['S', 'M', 'L', 'X']
                },
                gutter: {
                    col: [4, 4, 4, 4],
                    row: [7, 4, 4, 4]
                }
            });
            this.listing.hasMore;
        }
        super.onListingChange();
    }
    get localListing() {
        return this.listing as any as ProductListing<Product<IProductDataV2>>;
    }
}
